module.exports = __webpack_public_path__ + "img/qiepian.528deaf6.png";